import { applySitePrimaryColor } from '@/lib/colorTheme';
applySitePrimaryColor();

import { createApp, ref, watch } from "vue";
import Popper from "vue3-popper";
import { useForm, useField } from "vee-validate";
import * as yup from 'yup';
import { __ } from "@/lib/Utilities";
import { axios } from "lib/Init";
import LoginBanner from 'components/LoginBanner.vue';
import TwModal from 'components/TwModal.vue';

const app = createApp({
    setup() {
        const schema = yup.object({
            name: yup.string().required(__('login.validation.name_required')),
            password: yup.string().required(__('login.validation.password_required')),
        });

        const emailLinkSchema = yup.object({
            emailLinkEmail: yup.string()
                .required(__('login.validation.email_required'))
                .email(__('login.validation.email_invalid'))
                .matches(/^(?!.*\.\.)[a-zA-Z0-9](?:[a-zA-Z0-9._%+'-]{0,62}[a-zA-Z0-9])?@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/, __('login.validation.email_invalid'))
                .max(74, __('login.validation.email_invalid')),
        });

        const { handleSubmit, errors, meta } = useForm({
            validationSchema: schema,
        });

        const { value: name } = useField('name');
        const { value: password } = useField('password');

        const { handleSubmit: handleEmailLinkSubmit, errors: emailLinkValidationErrors } = useForm({
            validationSchema: emailLinkSchema,
        });
        const { value: emailLinkEmail } = useField('emailLinkEmail');

        const showEmailLinkModal = ref(false);
        const emailLinkSent = ref(false);
        const emailLinkSubmitting = ref(false);
        const emailLinkError = ref('');
        const emailLinkValidationAttempted = ref(false);

        watch(emailLinkEmail, () => {
            emailLinkError.value = '';
        });

        const closeEmailLinkModal = () => {
            showEmailLinkModal.value = false;
            emailLinkEmail.value = '';
            emailLinkSent.value = false;
            emailLinkSubmitting.value = false;
            emailLinkError.value = '';
            emailLinkValidationAttempted.value = false;
        };

        const submitEmailLinkForm = (event) => {
            emailLinkValidationAttempted.value = true;
            emailLinkError.value = '';

            handleEmailLinkSubmit(() => {
                emailLinkSubmitting.value = true;

                axios.post('/login/email-link', { email: emailLinkEmail.value })
                    .then((response) => {
                        if (response.data.success) {
                            emailLinkSent.value = true;
                            return;
                        }

                        emailLinkError.value = response.data.message || __('login.email_link_error');
                    })
                    .catch((error) => {
                        emailLinkError.value = error.response?.data?.message || __('login.email_link_error');
                    })
                    .finally(() => {
                        emailLinkSubmitting.value = false;
                    });
            })(event);
        };

        const submitForm = handleSubmit(() => {
            const form = document.getElementById('loginForm');

            if (form instanceof HTMLFormElement) {
                form.submit();
            } else {
                console.error('Form not found or is not a form element');
            }
        });

        const tooltipPlacement = window.innerWidth < 768 ? 'top' : 'right';

        const showForm = () => {
            const loginForm = document.getElementById("standardLogin");
            const loginText = document.getElementById("loginText");
            const ssoForgot = document.getElementById("ssoForgot");

            loginForm.classList.remove('tw-hidden');
            loginText.classList.add('tw-hidden');
            ssoForgot.classList.add('tw-hidden');
        };

        return {
            tooltipPlacement,
            name,
            password,
            errors,
            meta,
            showForm,
            submitForm,
            showEmailLinkModal,
            emailLinkEmail,
            emailLinkSent,
            emailLinkSubmitting,
            emailLinkError,
            emailLinkValidationAttempted,
            emailLinkValidationErrors,
            closeEmailLinkModal,
            submitEmailLinkForm,
        };
    },
    components: {
        'login-banner': LoginBanner,
        'v-popper': Popper,
        'tw-modal': TwModal,
    }
});

app.mount("#app");
